import React from 'react'
import { Typography } from '@mui/material'

export const OTP_PAGE_BENEFITS = [
    { textKey: 'specialOffers', icon: <Typography sx={{ fontSize: 18 }}>%</Typography> },
    { textKey: 'addTravellerInfo', icon: <Typography sx={{ fontSize: 18 }}>👤</Typography> },
    { textKey: 'quickCheckout', icon: <Typography sx={{ fontSize: 18 }}>⚡</Typography> },
    { textKey: 'manageBooking', icon: <Typography sx={{ fontSize: 18 }}>📋</Typography> },
    { textKey: 'immediateRefund', icon: <Typography sx={{ fontSize: 18 }}>💰</Typography> }
]
